import {ValueObject} from '@s-ui/domain'

import {IdSharedValueObject} from '../../shared/ValueObjects/IdSharedValueObject.js'
import {SluglifyValueObject} from './SluglifyValueObject.js'

export class SpecificationVehiclesValueObject extends ValueObject {
  #icon
  #id
  #name

  constructor({icon, id, name}) {
    super()
    this.#icon = icon
    this.#id = id
    this.#name = name
  }

  static isValidId({id}) {
    return IdSharedValueObject.safeValidate({id})
  }

  static empty() {
    return new SpecificationVehiclesValueObject({id: IdSharedValueObject.empty()})
  }

  static createFromLiterals({icon, id, name}) {
    return new SpecificationVehiclesValueObject({icon, id: IdSharedValueObject.createFromPrimitives({id}), name})
  }

  get icon() {
    return this.#icon
  }

  get id() {
    return this.#id.value
  }

  get name() {
    return this.#name
  }

  get value() {
    return {id: this.#id.value, ...(this.#icon && {icon: this.#icon}), ...(this.#name && {name: this.#name})}
  }

  toSlug() {
    return SluglifyValueObject.create({str: this.#name}).value
  }

  isEmpty() {
    return this.#id.isEmpty()
  }
}
